import { format } from 'date-fns';
import removeIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/trash.png'
import DeviceCard from './DeviceCard';
import { useDispatch } from 'react-redux';
import { deleteAjaxFromSite, removeAibox, unlinkDahua, unlinkHikvision } from '../../../../Api Methods/Api';
import { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import Lottie from 'lottie-react';
import areYouSure from '../../../../assets/animations/areYouSure.json'
import { Button } from 'primereact/button';
import { useSelector } from 'react-redux';

const IntegrationCard = ({integration, pinObject, apiData, siteUUID, showSuccess, refreshDevices}) => {

    const dispatch = useDispatch();
    const role = useSelector(state => state.auth.role);

    const integrationTitle = integration.integrationType
    const ID = integration.extraField1

    const parsed = integration?.extraField2
        ? JSON.parse(integration.extraField2)
        : [];

    const zoneName = ` ${parsed?.[0]?.zoneName || ""}`;
    let isControllingType = parsed?.[0]?.controlLevel || ""
    if (isControllingType == "output_relay") isControllingType = "Relays"
        if (isControllingType == "channel") isControllingType = "Channels"
    const isControlling = parsed?.[0]?.ruleUUIDs || ""

    const addedBy = integration.addedBy
    const dateAdded = integration.created_at

    const [showConfirm, setShowConfirm] = useState(false)
    

    const unlink = async () => {
      switch (integration.integrationType) {
        case "HIKVISION" : {
          const responseData = await unlinkHikvision(apiData, siteUUID, pinObject.Pin, dispatch)
          if (responseData.success) {
            setShowConfirm(false)
            showSuccess(true)
            refreshDevices()
          }
        }
        break;
        case "DAHUA": {
          const responseData = await unlinkDahua(apiData, siteUUID, pinObject.Pin, dispatch)
          if (responseData.success) {
            setShowConfirm(false)
            showSuccess(true)
            refreshDevices()
          }
        }
        break;
        case "AJAX": {
          const responseData = await deleteAjaxFromSite(apiData, siteUUID, ID, dispatch)
          if (responseData.data.success){
            setShowConfirm(false)
            showSuccess(true)
            refreshDevices()
          }
        }
        break;
        case "AIBOX": {
          const responseData = await removeAibox(apiData, siteUUID, pinObject.Pin, dispatch)
          if (responseData) {
            setShowConfirm(false)
            showSuccess(true)
            refreshDevices()
          }
        }
        break;
      }

    }

    return (
      <>

        <Dialog
            header="Are you sure?"
            visible={showConfirm}
            style={{ width: "40vw" }}
            onHide={() => setShowConfirm(false)}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                <Lottie
                    animationData={areYouSure}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
                <br />
                <h3 style={{ color: "#6e6e6eff" }}>{`Are you sure you want to unlink this ${integration.integrationType}?`}</h3>
                <br />
                <Button label="No cancel" icon="pi pi-times" severity="secondary" onClick={() => setShowConfirm(false)} />
                <br />
                <Button label="Yes, unlink" icon="pi pi-check" severity="danger" onClick={() => unlink()} />

            </div>
        </Dialog>
      
      
        <DeviceCard
          header={`${integrationTitle} ${zoneName}`}
          subHeader={
            isControllingType !== "rule"
              ? `${isControllingType} ${isControlling}`
              : "Rules"
          }
          meta={[ID]}
          rightContent={
            <>
              <h3 style={{color:"var(--Primary-Color)"}}>{pinObject.pinName}</h3>
              {(role === "admin" || role === "TechSupport") && <img src={removeIcon} style={{width:"25px", cursor:"pointer"}} onClick={() => setShowConfirm(true)} />}
            </>
          }
          footer={
            integration.addedBy &&
            `Added by ${addedBy.fullName} on ${format(
              new Date(dateAdded),
              "MMM do, yyyy"
            )}`
          }
        />
      </>
      );
}

export default IntegrationCard;